import AutoplayVideo from './AutoplayVideo';
import AutoplayVideoItem from './AutoplayVideoItem.theme2';
import styles from './AutoplayVideo.theme2.module.css';

export default function AutoplayVideoTheme2(props) {
  return <AutoplayVideo {...{ ...props, AutoplayVideoItem, styles }} />;
}
